$(function() {

  function setFacetTop(){
    var headerHeight = $('.header').outerHeight();
    $('.facets-wrapper').css('top', headerHeight + 'px');
  }

  setFacetTop();
  $(window).on('resize', setFacetTop);

  $('.collection-hero__title').click(function(){
    $(this).parent().toggleClass('description_open');
  });

});
